export const upsellsTypes = {
	UPSELL1: '/upsell1',
	UPSELL2: '/upsell2',
	UPSELL3: '/upsell3',
	UPSELL4: '/upsell4',
}
